import { useContext } from "react";
import { SafeAreaContext } from "./context";
export var useSafeArea = function () { return useContext(SafeAreaContext); };
